import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import MainLayout from "../Main";

import { IAssessmentLayoutProps } from "../../../interfaces/layouts";
import { AssessmentTab } from "../../../interfaces/assessment";

const AssessmentDetailsLayout = (props: IAssessmentLayoutProps) => {
    const { operation, currentTab, title, error, children } = props;

    const { assessment_id } = useParams();
    const navigate = useNavigate();

    const tabsList: AssessmentTab[] = ['Details', 'Immigration Recommendations'];

    const onChangeTab = (tab: AssessmentTab) => {
        if (tab === currentTab || operation === 'create') return;

        navigate(`/assessments/${assessment_id}/${tab.toLowerCase().replace(' ', '-')}`);
    };

    return (
        <MainLayout>
            <div className="immployer__common_details__layout">
                <div className="immployer__form_details__head" style={{ justifyContent: 'space-between' }}>
                    <h2 className="color_dark">{title}</h2>
                    {operation !== 'create' &&
                        <button
                            className="immployer__btn immployer__btn__primary"
                            onClick={() => navigate('/assessments')}
                        >
                            Need another assessment?
                        </button>
                    }
                </div>
                <div className="immployer__common_details__tabs__container">
                    <div className="immployer__tabs">
                        {tabsList.map(tab =>
                            <button
                                key={tab}
                                className={`immployer__tab ${currentTab === tab ? "immployer__tab__active" : ""} ${(operation === 'create' && tab !== "Details") ? 'immployer__tab__disabled' : ''}`}
                                onClick={() => onChangeTab(tab)}
                            >
                                {tab}
                            </button>
                        )}
                    </div>
                </div>
                <div className="immployer__common_details__content">
                    {
                        error
                            ? <div className="immployer__common_details__error_view">
                                <br /><br />
                                <h4 className="color_dark text_center">Error occured while fetching the data.</h4>
                                <h4 className="color_dark text_center">Please try again later.</h4>
                            </div>
                            : children
                    }
                </div>
            </div>
        </MainLayout>
    );
};

export default AssessmentDetailsLayout;